const searchModal = document.querySelector('.search-modal');
const openModalButton = document.querySelector('[data-open-search-modal]');
const closeModalButton = document.querySelector('[data-close-search-modal]');
const modalContent = searchModal.querySelector('.modal-content');
const input = searchModal.querySelector('[data-search-query]');
const searchButton = document.querySelector('[data-search]');
const clearButton = document.querySelector('.clear-button');
const searchAllButton = searchModal.querySelector('.search-all-button');
const searchRulesButton = searchModal.querySelector('.search-rules-button');

function closeSearchModal() {
    isSearchExpanded = false;
    searchModal.setAttribute('tabindex', '-1');
    searchModal.setAttribute('inert', '');
    searchModal.setAttribute('hidden', '');
    searchModal.classList.remove('active');
    document.body.classList.remove('no-scroll');
}

function handleInputState() {
    const value = input.value.trim();
    clearButton.style.display = value ? 'flex' : 'none';

    if (value) {
        searchButton.removeAttribute('disabled');
    } else {
        searchButton.setAttribute('disabled', '');
    }
}

input.addEventListener('input', () => {
    if (clearButton) {
        clearButton.style.display = input.value ? 'flex' : 'none';
    }
    handleInputState();
});

if (clearButton) {
    clearButton.addEventListener('click', () => {
        input.value = '';
        clearButton.style.display = 'none';
        input.focus();
    });
}

function activateButton(activeBtn, inactiveBtn) {
    activeBtn.setAttribute('aria-checked', 'true');
    inactiveBtn.setAttribute('aria-checked', 'false');

    activeBtn.classList.add('active');
    inactiveBtn.classList.remove('active');
}

openModalButton.addEventListener('click', function () {
    isSearchExpanded = true;
    searchModal.setAttribute('tabindex', '1');
    searchModal.removeAttribute('inert');
    searchModal.removeAttribute('hidden');
    openModalButton.setAttribute('aria-expanded', 'true');
    searchModal.classList.add('active');
    document.body.classList.add('no-scroll');
    searchModal.querySelector('[data-search-query]').focus();
});

closeModalButton.addEventListener('click', () => {
    closeSearchModal();
});

searchModal.addEventListener('click', (e) => {
    if (!modalContent.contains(e.target)) {
        closeSearchModal();
    }
});

let isSearchExpanded = false;

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchModal.classList.contains('active')) {
        closeSearchModal();
    }
});

// Detect screen size change
let lastWidth = window.innerWidth;

window.addEventListener('resize', function () {
    if (!isSearchExpanded) return;

    if (window.innerWidth !== lastWidth) {
        closeSearchModal();
    }

    lastWidth = window.innerWidth;
});

closeModalButton.addEventListener('click', function () {
    closeSearchModal();
});

function updateFilterButtons(activeBtn, inactiveBtn) {
    activeBtn.setAttribute('aria-checked', 'true');
    activeBtn.classList.add('active');

    inactiveBtn.setAttribute('aria-checked', 'false');
    inactiveBtn.classList.remove('active');
}

searchAllButton.addEventListener('click', () => {
    updateFilterButtons(searchAllButton, searchRulesButton);
});

searchRulesButton.addEventListener('click', () => {
    updateFilterButtons(searchRulesButton, searchAllButton);
});

updateFilterButtons(searchAllButton, searchRulesButton);